/*
 * File: ZoominfoEmployeeChart.tsx
 * Project: a-a
 * File Created: Tuesday, 4th November 2025 11:06:02 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 6th November 2025 12:40:18 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import zeplinColor from '../../../../theme/Color';

const formatNumber = (num: number): string => {
  if (num >= 1_000_000_000) {
    return `${(num / 1_000_000_000).toFixed(2)}B`; // Billion
  } else if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(2)}M`; // Million
  } else if (num >= 1_000) {
    return `${(num / 1_000).toFixed(2)}k`; // Thousand
  }
  return num.toString(); // Less than 1,000
};
const ZoominfoEmployeeChart = ({ data, loading }: { data: any; loading: boolean }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  const isXl = useMediaQuery(theme.breakpoints.up('xl')); // 1200px - 1536px

  // const data = {
  //   breakdown: [
  //     { platform: 'instagram', followers: 372931261, percentage: 73.08 },

  //     { platform: 'facebook', followers: 41444551, percentage: 8.12 },

  //     { platform: 'youtube', followers: 56600000, percentage: 11.09 },

  //     { platform: 'tiktok', followers: 39300000, percentage: 7.7 },
  //   ],
  //   changePercent: 0.32,
  //   formattedNewMonthly: '1.63M',
  //   newMonthly: 1633628,
  //   total: 510275812,
  // };
  const transformedValue =
    (Object.keys(data)?.length &&
      Object.entries(data || {}).map(([key, value]: any) => ({ platform: key, count: value }))) ||
    [];
  console.log({ data, transformedValue });
  const platformColors = [
    zeplinColor.Blue4, // Instagram
    '#F3A03F', // Facebook
    '#8F42EB', // Snapchat
    '#45C7EB', // TikTok
    '#DD67F0', // X
    '#2BDF89', // YouTube
    zeplinColor.USER_PROFILE_COLOR1,
    zeplinColor.USER_PROFILE_COLOR2,
    zeplinColor.USER_PROFILE_COLOR3,
    zeplinColor.USER_PROFILE_COLOR4,
    zeplinColor.USER_PROFILE_COLOR5,
    zeplinColor.USER_PROFILE_COLOR6,
    zeplinColor.USER_PROFILE_COLOR7,
  ];
  return (
    <Box
      sx={{
        flex: 1,
        borderRadius: '14px',
        padding: { xs: '12px 16px 16px 16px', xl: '24px 16px 16px 16px' },
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        // height: '338px',
        overflowY: 'auto',
        position: 'relative',
      }}
    >
      {' '}
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            // justifyContent: 'space-between',
            // marginTop: '10%',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          {/* <Skeleton variant='circular' width={40} height={40} /> */}
          <Skeleton variant='circular' width={200} height={200} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              // justifyContent: 'space-between',
              // marginTop: '10%',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '8rem',
              }}
            />
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '8rem',
              }}
            />
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '8rem',
              }}
            />
          </Box>
        </Box>
      ) : transformedValue?.length > 0 ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          <Box
            sx={{
              position: 'relative',

              //   alignItems: 'center',
              //   display: 'flex',
              //   flexDirection: 'column',
            }}
          >
            {transformedValue?.length > 0 && (
              <PieChart
                sx={{ height: { xs: '12rem', xl: '15rem' }, position: 'relative', left: '25%' }}
                hideLegend={true}
                series={[
                  {
                    data: transformedValue?.map((item: any, index: any) => ({
                      id: index,
                      value: item.count,
                      label: item.platform.charAt(0).toUpperCase() + item.platform.slice(1), // Capitalize platform name
                      color: platformColors[index], // Map color based on index
                    })),
                    innerRadius: isXs ? 80 : isXl ? 90 : 80,
                    // outerRadius: 100,
                    paddingAngle: 2,
                    cornerRadius: 3,

                    // startAngle: 0,
                    // endAngle: 0,

                    cx: 110,
                    // cy: 150,
                  },
                ]}
              />
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              justifyContent: 'center',
            }}
          >
            {transformedValue?.map((val: any, ind: number) => (
              <Box
                sx={{
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'center',
                  //   justifyContent: 'space-between',
                }}
              >
                {/* <img src={'/assets/due-logo.png'} width={'20px'} height={'20px'} /> */}
                <Box
                  sx={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: platformColors[ind], // Use the color from the data
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    gap: '42px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    // flex: 1,
                  }}
                >
                  <Typography variant='responsiveBody3' sx={{ width: '8rem' }}>
                    {val?.platform.charAt(0).toUpperCase() + val?.platform.slice(1)}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '4px',
                      alignItems: 'center',
                      // justifyContent: 'space-between',
                      justifyContent: 'flex-end', // Align the second part to the right
                      //   flex: 1,
                    }}
                  >
                    {/* <Typography variant='responsiveHeading4'>
                      {`${val?.percentage?.toFixed(2)}`}%
                    </Typography> */}
                    <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
                      {formatNumber(val?.count)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            width: '42%',
            margin: 'auto',
            display: 'flex',
            backgroundColor: zeplinColor.Neutral1,
            flexDirection: 'column',
            gap: '24px',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={'/assets/no-chart.svg'} width={'36px'} height={'36px'} alt='no-chart' />
          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Typography variant='responsiveHeading3'>No Data Available</Typography>
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
              There’s no data to display right now. Data will appear here automatically once
              available.
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ZoominfoEmployeeChart;
